<!-- =========================================================
     Short Course Admin List
========================================================= -->

<section class="ecb-x-admin-list-section">

    <div class="container-fluid">

        <div class="ecb-x-admin-list-card">


            <!-- =====================================================
                 Page Header
            ====================================================== -->

            <div class="ecb-x-admin-list-header">

                <!-- Left -->
                <div class="ecb-x-admin-list-title">

                    <h1 class="fw-bold mb-1">
                        Short Courses
                    </h1>

                    <p class="mb-0">
                        Manage public short course details, course content,
                        images, brochures and assessment information.
                    </p>

                </div>


                <!-- Right -->
                <div class="ecb-x-admin-list-actions">
                    <!-- Download Courses -->
                    <button type="button" class="ecb-x-admin-download-button" (click)="openDownloadDialog()">

                        <i class="bi bi-file-earmark-excel"></i>
                        Download Excel

                    </button>

                    <button type="button" class="ecb-x-admin-add-button" (click)="openNewCourse()">
                        <i class="bi bi-plus-lg"></i>
                        Add Short Course
                    </button>

                    <div class="search_group">
                        <!-- Search -->
                        <div class="ecb-x-admin-search-wrapper">

                            <i class="bi bi-search"></i>

                            <input type="search" class="form-control" [(ngModel)]="searchText"
                                (ngModelChange)="onSearchChange()" placeholder="Search name or code"
                                aria-label="Search short courses by name or code">

                        </div>

                        <button type="button" class="ecb-x-admin-add-button" (click)="onSearchChange()">
                            <i class="bi bi-search"></i>
                        </button>
                    </div>

                    <!-- Start State Selection -->
                    <div class="ecb-states-select-wrapper">
                        <p-selectButton [options]="statesList" [(ngModel)]="selectedStateCode" optionLabel="siteName"
                            optionValue="code" [multiple]="false" [allowEmpty]="false"
                            (onChange)="onStateChange($event.value)" styleClass="ecb-states-select-button">
                        </p-selectButton>
                    </div>
                    <!-- End State Selection -->

                    <!-- Course Type -->
                    <div class="ecb-x-admin-filter-wrapper">

                        <select class="form-select" [(ngModel)]="courseType" (change)="onCourseTypeChange()">

                            <option value="ALL">
                                All
                            </option>

                            <option value="UOC">
                                UOC
                            </option>

                            <option value="SS">
                                Skill Sets
                            </option>

                            <option value="HRC">
                                HRC
                            </option>

                            <option value="HSR">
                                HSR
                            </option>



                        </select>

                    </div>


                    <!-- Visibility Filter -->

                    <div class="ecb-x-admin-filter-wrapper">

                        <select class="form-select" [(ngModel)]="visibilityFilter" (change)="onVisibilityFilterChange()"
                            aria-label="Filter by visibility">

                            <option value="ALL">
                                All Visibility
                            </option>

                            <option value="ACTIVE">
                                Active
                            </option>

                            <option value="INACTIVE">
                                Inactive
                            </option>

                        </select>

                    </div>


                </div>

            </div>


            <!-- =====================================================
                 PrimeNG Table
            ====================================================== -->

            <div class="ecb-x-admin-table-container">

                <p-table #courseTable [value]="paginatedCourses" [loading]="isLoading" [scrollable]="true" [tableStyle]="{
        'min-width': '1280px'
    }" styleClass="ecb-admin-table">


                    <!-- =================================================
         Header
    ================================================== -->

                    <ng-template pTemplate="header">

                        <tr class="ecb-admin-table-header-row">

                            <th class="ecb-admin-table-header ecb-col-image">
                                IMAGE
                            </th>

                            <th class="ecb-admin-table-header ecb-col-code">
                                CODE
                            </th>

                            <th class="ecb-admin-table-header ecb-col-course">
                                COURSE
                            </th>

                            <th class="ecb-admin-table-header ecb-col-price">
                                PRICE
                            </th>

                            <th class="ecb-admin-table-header ecb-col-calendar">
                                CALENDAR
                            </th>

                            <th class="ecb-admin-table-header ecb-col-vettrak">
                                VETTRAK
                            </th>

                            <th class="ecb-admin-table-header ecb-col-status">
                                STATUS
                            </th>

                            <th class="ecb-admin-table-header ecb-admin-table-action-header">
                                ACTION
                            </th>

                        </tr>

                    </ng-template>


                    <!-- =================================================
         Body
    ================================================== -->

                    <ng-template pTemplate="body" let-course>

                        <tr class="ecb-admin-table-row"
                            [class.ecb-admin-table-row-hrc]="course.isHighRiskCourse === true"
                            [class.ecb-admin-table-row-ss]="course.isSkillSetsCourse === true"
                            [class.ecb-admin-table-row-hsr]="course.isHsrCourse === true">


                            <!-- Image -->

                            <td class="ecb-admin-table-cell">

                                <div class="ecb-x-admin-table-image">

                                    <img *ngIf="hasCourseImage(course)" [src]="course.imageUrl"
                                        [alt]="getCourseTitle(course)" (error)="onImageError(course)">

                                    <div class="ecb-x-admin-table-image-fallback" *ngIf="!hasCourseImage(course)">

                                        <i class="bi bi-mortarboard"></i>

                                    </div>

                                </div>

                            </td>


                            <!-- Code -->

                            <td class="ecb-admin-table-cell">

                                <span class="ecb-x-admin-course-code">
                                    {{ getCourseCode(course) }}
                                </span>

                            </td>


                            <!-- Course -->

                            <td class="ecb-admin-table-cell">

                                <div class="ecb-x-admin-course-info">

                                    <div class="ecb-x-admin-course-title">
                                        {{ getTableCourseTitle(course) }}
                                    </div>

                                    <div class="ecb-x-admin-course-description">
                                        {{ getCourseDescription(course) }}
                                    </div>

                                </div>

                            </td>


                            <!-- Price -->

                            <td class="ecb-admin-table-cell">

                                <span class="ecb-x-admin-price">
                                    {{ getPrice(course) }}
                                </span>

                            </td>


                            <!-- Calendar -->

                            <td class="ecb-admin-table-cell">

                                <span class="ecb-x-admin-calendar-badge"
                                    [class.available]="course.isCourseAvailableInCalendar"
                                    [class.unavailable]="!course.isCourseAvailableInCalendar">

                                    <i class="bi" [ngClass]="
                            course.isCourseAvailableInCalendar
                                ? 'bi-calendar-check'
                                : 'bi-calendar-x'
                        ">
                                    </i>

                                    {{
                                    course.isCourseAvailableInCalendar
                                    ? 'Available'
                                    : 'Not Available'
                                    }}

                                </span>

                            </td>


                            <!-- VETtrak Link / Sync Status -->

                            <td class="ecb-admin-table-cell">

                                <div class="ecb-vettrak-table-status" [class.linked]="course.wasSyncedFromVettrak"
                                    [class.manual]="!course.wasSyncedFromVettrak">

                                    <div class="ecb-vettrak-table-badge">

                                        <i class="bi" [ngClass]="
                                                course.wasSyncedFromVettrak
                                                    ? 'bi-cloud-check-fill'
                                                    : 'bi-person-fill-add'
                                            ">
                                        </i>

                                        <span>
                                            {{
                                            course.wasSyncedFromVettrak
                                            ? 'VETtrak Linked'
                                            : 'Manual'
                                            }}
                                        </span>

                                    </div>

                                    <small class="ecb-x-admin-course-description" *ngIf="
                                        course.wasSyncedFromVettrak &&
                                        course.lastVettrakSyncUtc
                                    ">

                                        {{
                                        course.lastVettrakSyncUtc
                                        | date:'dd/MM/yyyy h:mm a':'UTC'
                                        }}
                                        UTC
                                    </small>

                                    <small class="ecb-x-admin-course-description" *ngIf="!course.wasSyncedFromVettrak">
                                        Not synced from VETtrak
                                    </small>

                                </div>

                            </td>


                            <!-- Status -->

                            <td class="ecb-admin-table-cell">

                                <span class="ecb-x-admin-status-badge" [class.active]="course.isActive"
                                    [class.inactive]="!course.isActive">

                                    {{
                                    course.isActive
                                    ? 'Active'
                                    : 'Inactive'
                                    }}

                                </span>

                            </td>


                            <!-- Action -->

                            <td class="ecb-admin-table-cell ecb-admin-table-action-cell">



                                <button type="button" class="ecb-admin-table-action-button ecb-admin-table-edit-button"
                                    (click)="openCourseDetails(course)"
                                    [attr.aria-label]="'Edit ' + getCourseTitle(course)" title="Edit course">

                                    <i class="bi bi-pencil-square ecb-admin-table-action-icon"></i>

                                </button>

                                <button type="button"
                                    class="ecb-admin-table-action-button ecb-admin-table-delete-button"
                                    (click)="requestDeleteCourse(course)"
                                    [disabled]="deletingCourseId === getCourseId(course)"
                                    [attr.aria-label]="'Delete ' + getCourseTitle(course)" title="Delete course">

                                    <i class="bi" [ngClass]="
                                                deletingCourseId === getCourseId(course)
                                                    ? 'bi-hourglass-split'
                                                    : 'bi-trash3'
                                            ">
                                    </i>

                                </button>



                            </td>

                        </tr>

                    </ng-template>


                    <!-- =================================================
         Empty
    ================================================== -->

                    <ng-template pTemplate="emptymessage">

                        <tr class="ecb-admin-table-row">

                            <td colspan="8" class="ecb-admin-table-cell">

                                <div class="ecb-x-admin-table-empty">

                                    <div class="ecb-x-admin-empty-icon">

                                        <i class="bi bi-journal-x"></i>

                                    </div>

                                    <h3>
                                        No Courses Available
                                    </h3>

                                    <p>
                                        There are currently no courses available.
                                    </p>

                                </div>

                            </td>

                        </tr>

                    </ng-template>


                    <!-- =================================================
         Loading
    ================================================== -->

                    <ng-template pTemplate="loadingbody">

                        <tr class="ecb-admin-table-row">

                            <td colspan="8" class="ecb-admin-table-cell">

                                <div class="ecb-x-admin-table-loading">

                                    <div class="spinner-border spinner-border-sm" role="status">
                                    </div>

                                    <span>
                                        Loading courses...
                                    </span>

                                </div>

                            </td>

                        </tr>

                    </ng-template>

                </p-table>

                <!-- =====================================================
                     Pagination - same UI pattern as Manual Sync
                ====================================================== -->

                <div class="ecb-short-pagination" *ngIf="filteredCourses.length > 0">

                    <div class="ecb-short-pagination-summary">
                        Showing {{ pageStart }}-{{ pageEnd }} of {{ filteredCourses.length }} courses
                    </div>

                    <div class="ecb-short-page-size">
                        <label for="shortCoursePageSize">Rows per page</label>

                        <select id="shortCoursePageSize" [value]="pageSize"
                            (change)="changePageSize($any($event.target).value)">

                            <option *ngFor="let option of pageSizeOptions" [value]="option">
                                {{ option }}
                            </option>

                        </select>
                    </div>

                    <div class="ecb-short-page-controls">

                        <button type="button" (click)="changePage(currentPage - 1)" [disabled]="currentPage === 1">
                            Previous
                        </button>

                        <button type="button" *ngFor="let page of pageNumbers" [class.active]="page === currentPage"
                            (click)="changePage(page)">
                            {{ page }}
                        </button>

                        <button type="button" (click)="changePage(currentPage + 1)"
                            [disabled]="currentPage === totalPages">
                            Next
                        </button>

                    </div>

                </div>

            </div>

        </div>

    </div>

</section>


<!-- =========================================================
     Delete Short Course Confirmation Modal
========================================================= -->

<div class="ecb-delete-confirm-backdrop" *ngIf="showDeleteModal" (click)="closeDeleteModal()">

    <div class="ecb-delete-confirm-modal" (click)="$event.stopPropagation()">

        <div class="ecb-delete-confirm-icon">
            <i class="bi bi-trash3"></i>
        </div>

        <div class="ecb-delete-confirm-content">

            <div class="ecb-delete-confirm-eyebrow">
                DELETE SHORT COURSE
            </div>

            <h3>
                Are you sure you want to delete this course?
            </h3>

            <div class="ecb-delete-confirm-course" *ngIf="pendingDeleteCourse">

                <strong>
                    {{ getCourseCode(pendingDeleteCourse) }}
                </strong>

                <span>
                    {{ getCourseTitle(pendingDeleteCourse) }}
                </span>

            </div>

            <p>
                This permanently removes the short course and its VETtrak
                occurrence, class and unit data. If the course is linked to
                Manual Sync, the linked source URL is removed as well.
            </p>

            <div class="ecb-delete-confirm-warning">
                <i class="bi bi-exclamation-triangle-fill"></i>
                <span>This action cannot be undone.</span>
            </div>

            <div class="ecb-delete-confirm-error" *ngIf="errorMessage">

                <i class="bi bi-exclamation-circle-fill"></i>

                <span>
                    {{ errorMessage }}
                </span>

            </div>

        </div>

        <div class="ecb-delete-confirm-actions">

            <button type="button" class="ecb-delete-cancel-button" [disabled]="deletingCourseId !== null"
                (click)="closeDeleteModal()">

                Cancel

            </button>

            <button type="button" class="ecb-delete-confirm-button" [disabled]="deletingCourseId !== null"
                (click)="confirmDeleteCourse()">

                <span class="spinner-border spinner-border-sm" *ngIf="deletingCourseId !== null">
                </span>

                <i class="bi bi-trash3" *ngIf="deletingCourseId === null">
                </i>

                {{
                deletingCourseId !== null
                ? 'Deleting...'
                : 'Delete Course'
                }}

            </button>

        </div>

    </div>

</div>

<!-- =========================================================
     Start Edit Course Modal
========================================================= -->

<div class="ecb-x-admin-modal-backdrop" *ngIf="showEditModal">

    <div class="ecb-x-admin-modal" (click)="$event.stopPropagation()">


        <!-- =====================================================
         Modal Header
    ====================================================== -->

        <div class="ecb-x-admin-modal-header">

            <div class="d-flex align-items-center gap-3 min-w-0">

                <div class="ecb-x-admin-modal-title-icon">

                    <i class="bi" [ngClass]="isCreateMode ? 'bi-plus-circle' : 'bi-pencil-square'"></i>

                </div>


                <div class="overflow-hidden">

                    <div class="small fw-bold ecb-x-admin-modal-eyebrow">
                        {{ isCreateMode ? 'NEW SHORT COURSE' : 'COURSE MANAGEMENT' }}
                    </div>

                    <h2 class="fs-6 fw-bold text-white mb-0
                   text-truncate">

                        {{
                        CourseDetails?.courseTitle ||
                        (isCreateMode ? 'Add Short Course' : 'Course Details')
                        }}

                    </h2>

                </div>

            </div>


            <button type="button" class="ecb-x-admin-modal-close" [disabled]="
          isSaving ||
          isUploadingImage ||
          isUploadingBrochure
        " (click)="closeCourseModal()">

                <i class="bi bi-x-lg"></i>

            </button>

        </div>



        <!-- =====================================================
         Loading Details
    ====================================================== -->

        <div class="ecb-x-admin-modal-loading" *ngIf="isDetailsLoading">

            <div class="spinner-border text-warning">
            </div>

            <span class="small text-muted">
                Loading course details...
            </span>

        </div>



        <!-- =====================================================
         Modal Body
    ====================================================== -->

        <div class="ecb-x-admin-modal-body" *ngIf="
        !isDetailsLoading &&
        CourseDetails
      ">


            <!-- Success -->

            <div class="alert alert-success
               d-flex align-items-center gap-2 py-2" *ngIf="successMessage">

                <i class="bi bi-check-circle-fill"></i>

                <span class="small">
                    {{ successMessage }}
                </span>

            </div>


            <!-- Error -->

            <div class="alert alert-danger
               d-flex align-items-center gap-2 py-2" *ngIf="errorMessage">

                <i class="bi bi-exclamation-circle-fill"></i>

                <span class="small">
                    {{ errorMessage }}
                </span>

            </div>



            <!-- ===================================================
           Basic Information
      ==================================================== -->

            <div class="ecb-x-admin-form-section">

                <div class="ecb-x-admin-section-heading">

                    <div>

                        <div class="small fw-bold text-warning
                     text-uppercase mb-1">

                            Basic Information

                        </div>

                        <h3 class="fs-6 fw-bold mb-0">
                            Course Details
                        </h3>

                    </div>

                    <div class="col-md-2">

                        <label class="form-label fw-semibold d-block">
                            Location
                        </label>
                        <div class="ecb-states-select-wrapper">


                            <p-selectButton [options]="statesList" [(ngModel)]="selectedFormStateCode"
                                optionLabel="siteName" optionValue="code" [multiple]="false" [allowEmpty]="false"
                                (onChange)="onFormStateChange($event.value)" styleClass="ecb-states-select-button">
                            </p-selectButton>

                        </div>
                    </div>


                </div>


                <div class="row g-4">

                    <!-- Course Code -->
                    <div class="col-md-3">

                        <label class="form-label fw-semibold">
                            Course Code
                            <span class="text-danger">*</span>
                        </label>

                        <input type="text" class="form-control" maxlength="50" [disabled]="!isCreateMode"
                            [(ngModel)]="CourseDetails.courseCode" name="courseCode" placeholder="e.g. HLTAID011">

                    </div>


                    <!-- Course Title -->
                    <div class="col-md-6">

                        <label class="form-label fw-semibold">
                            Course Title
                            <span class="text-danger">*</span>
                        </label>

                        <input type="text" class="form-control" maxlength="250" [disabled]="!isCreateMode"
                            [(ngModel)]="CourseDetails.courseTitle" name="courseTitle" placeholder="Enter course title">

                    </div>


                    <!-- Admin Course Type -->
                    <!-- <div class="col-md-3">
                        <label class="form-label fw-semibold">Course Type</label>
                        <select class="form-select" [(ngModel)]="CourseDetails.adminCourseType" name="adminCourseType">
                            <option value="UOC">UOC</option>
                            <option value="OSC">Other Short Course</option>
                            <option value="HRC">High Risk Course</option>
                        </select>
                    </div> -->


                    <!-- Price -->
                    <div class="col-md-3">
                        <label class="form-label fw-semibold">Price</label>
                        <input type="number" min="0" step="0.01" class="form-control"
                            [(ngModel)]="CourseDetails.totalAmount" name="totalAmount">
                    </div>


                    <!-- Currency -->
                    <!-- <div class="col-md-2">
                        <label class="form-label fw-semibold">Currency</label>
                        <input type="text" maxlength="3" class="form-control text-uppercase"
                            [(ngModel)]="CourseDetails.currencyCode" name="currencyCode">
                    </div> -->


                    <!-- Document Types -->
                    <!-- <div class="col-md-4">
                        <label class="form-label fw-semibold">Document Types</label>
                        <input type="text" maxlength="50" class="form-control"
                            [(ngModel)]="CourseDetails.documentTypes" name="documentTypes"
                            placeholder="Optional">
                    </div> -->


                    <!-- Visibility -->
                    <div class="col-md-3">
                        <label class="form-label fw-semibold">Visibility</label>
                        <select class="form-select" [(ngModel)]="CourseDetails.isActive" name="isActive">
                            <option [ngValue]="true">Active</option>
                            <option [ngValue]="false">Inactive</option>
                        </select>
                    </div>


                    <!-- High Risk Course -->

                    <!-- High Risk Course -->
                    <div class="col-md-2">
                        <label class="form-label fw-semibold d-block">
                            High Risk Course
                        </label>

                        <div class="ecb-sync-switch-wrapper"
                            [class.ecb-sync-switch-disabled]="CourseDetails.isSkillSetsCourse">

                            <label class="ecb-sync-switch">
                                <input type="checkbox" [ngModel]="CourseDetails.isHighRiskCourse"
                                    (ngModelChange)="onHighRiskChange($event)" name="isHighRiskCourse"
                                    [disabled]="CourseDetails.isSkillSetsCourse">

                                <span class="ecb-sync-slider"></span>
                            </label>

                            <span class="ecb-sync-status">
                                {{ CourseDetails.isHighRiskCourse ? 'On' : 'Off' }}
                            </span>
                        </div>
                    </div>


                    <!-- HSR Course -->
                    <div class="col-md-2">
                        <label class="form-label fw-semibold d-block">
                            HSR Course
                        </label>

                        <div class="ecb-sync-switch-wrapper"
                            [class.ecb-sync-switch-disabled]="CourseDetails.isSkillSetsCourse">

                            <label class="ecb-sync-switch">
                                <input type="checkbox" [ngModel]="CourseDetails.isHsrCourse"
                                    (ngModelChange)="onHsrChange($event)" name="isHsrCourse"
                                    [disabled]="CourseDetails.isSkillSetsCourse">

                                <span class="ecb-sync-slider"></span>
                            </label>

                            <span class="ecb-sync-status">
                                {{ CourseDetails.isHsrCourse ? 'On' : 'Off' }}
                            </span>
                        </div>
                    </div>


                    <div class="col-md-3">

                    </div>


                    <!-- Course Type -->
                    <div class="col-md-2">

                        <label class="form-label fw-semibold d-block">
                            Course Type
                        </label>

                        <div class="ecb-course-type-select-wrapper">

                            <p-selectButton [options]="courseTypeOptions" [(ngModel)]="CourseDetails.isSkillSetsCourse"
                                name="isSkillSetsCourse" optionLabel="label" optionValue="value" [allowEmpty]="false"
                                styleClass="ecb-course-type-select-button" (onChange)="onCourseTypeSelect()">
                            </p-selectButton>

                        </div>

                    </div>

                </div>

                <div class="ecb-vettrak-sync-card" *ngIf="!isCreateMode">
                    <div class="ecb-vettrak-sync-main">
                        <div class="ecb-vettrak-sync-icon">
                            <i class="bi bi-info-circle "></i>
                        </div>

                        <div class="flex-grow-1">
                            <div class="ecb-vettrak-sync-title">
                                Select High Risk Course Or HSR Course - not both.
                            </div>



                            <div class="ecb-vettrak-sync-meta">
                                For Short Courses, enable either option or leave both off. These are independent
                                switches and may both be off, but only one may be on at a time.
                            </div>

                        </div>


                    </div>
                </div>


                <!-- <div class="ecb-vettrak-sync-card" *ngIf="!isCreateMode">
                    <div class="ecb-vettrak-sync-main">
                        <div class="ecb-vettrak-sync-icon" [class.synced]="CourseDetails.wasSyncedFromVettrak">
                            <i class="bi"
                                [ngClass]="CourseDetails.wasSyncedFromVettrak ? 'bi-cloud-check-fill' : 'bi-cloud-slash'"></i>
                        </div>

                        <div class="flex-grow-1">
                            <div class="ecb-vettrak-sync-title">
                                {{ CourseDetails.wasSyncedFromVettrak
                                ? 'Synced using VETtrak manual sync URL'
                                : 'Not synced using VETtrak' }}
                            </div>

                            <div class="ecb-vettrak-sync-meta" *ngIf="CourseDetails.wasSyncedFromVettrak">
                                Last successful sync:
                                <strong>{{ CourseDetails.lastVettrakSyncUtc | date:'dd/MM/yyyy, h:mm a':'UTC' }}
                                    UTC</strong>
                                <span *ngIf="CourseDetails.syncProgramId"> · Program {{ CourseDetails.syncProgramId
                                    }}</span>
                                <span *ngIf="CourseDetails.syncStatus"> · {{ CourseDetails.syncStatus }}</span>
                            </div>

                            <div class="ecb-vettrak-sync-meta" *ngIf="!CourseDetails.wasSyncedFromVettrak">
                                This course has no successful VETtrak URL sync recorded. It may have been added
                                manually.
                            </div>

                            <a *ngIf="CourseDetails.syncSourceUrl" [href]="CourseDetails.syncSourceUrl" target="_blank"
                                rel="noopener noreferrer" class="ecb-vettrak-source-link">
                                <i class="bi bi-box-arrow-up-right"></i>
                                View VETtrak source URL
                            </a>
                        </div>

                        <div class="ecb-sync-description-control">
                            <label class="form-label fw-semibold mb-1">Sync description</label>
                            <div class="ecb-sync-switch-wrapper" >
                                <label class="ecb-sync-switch">
                                    <input type="checkbox" [(ngModel)]="CourseDetails.isSyncActive" name="isSyncActive" [disabled]="true">
                                    <span class="ecb-sync-slider"></span>
                                </label>
                                <span class="ecb-sync-status">{{ CourseDetails.isSyncActive ? 'On' : 'Off' }}</span>
                            </div>
                        </div>
                    </div>
                </div> -->

                <div class="row pt-2">
                    <div class="col-md-12">
                        <div class="ecb-x-admin-editor-field">

                            <label class="form-label fw-semibold">
                                Description
                            </label>

                            <p-editor [(ngModel)]="CourseDetails.description" name="description"
                                [modules]="editorModules" [style]="{
    height: '180px'
  }">
                            </p-editor>

                        </div>
                    </div>
                </div>

            </div>



            <!-- ===================================================
           Media
      ==================================================== -->

            <div class="ecb-x-admin-form-section">

                <div class="ecb-x-admin-section-heading">

                    <div>

                        <div class="small fw-bold text-warning
                     text-uppercase mb-1">

                            Course Media

                        </div>

                        <h3 class="fs-6 fw-bold mb-0">
                            Image & Brochure
                        </h3>

                    </div>

                    <i class="bi bi-images text-muted fs-5"></i>

                </div>


                <div class="row g-4">


                    <!-- =================================================
               Image
          ================================================== -->

                    <div class="col-lg-8">

                        <label class="form-label fw-semibold">
                            Course Image
                        </label>


                        <div class="ecb-x-admin-image-upload-box">


                            <!-- Preview -->

                            <div class="ecb-x-admin-image-preview">

                                <img *ngIf="imagePreviewUrl" [src]="imagePreviewUrl" alt="Course image">


                                <div class="ecb-x-admin-image-preview-empty" *ngIf="!imagePreviewUrl">

                                    <i class="bi bi-image fs-2 text-primary"></i>

                                    <span class="small text-muted">
                                        No course image
                                    </span>

                                </div>


                                <!-- Uploading -->

                                <div class="ecb-x-admin-image-upload-loader" *ngIf="isUploadingImage">

                                    <div class="spinner-border spinner-border-sm">
                                    </div>

                                    <span class="small">
                                        Uploading image...
                                    </span>

                                </div>

                            </div>


                            <!-- Buttons -->

                            <div class="d-flex flex-column
                       flex-sm-row gap-2 mt-3">

                                <label class="btn btn-primary btn-sm
                         d-inline-flex align-items-center
                         justify-content-center gap-2 mb-0" [class.disabled]="isUploadingImage">

                                    <i class="bi bi-cloud-arrow-up"></i>

                                    Choose Image

                                    <input type="file" hidden accept="image/*" [disabled]="isUploadingImage"
                                        (change)="uploadImage($event)">

                                </label>


                                <button type="button" class="btn btn-outline-danger btn-sm" *ngIf="imagePreviewUrl"
                                    [disabled]="isUploadingImage" (click)="removeCourseImage()">

                                    <i class="bi bi-trash3 me-1"></i>

                                    Remove

                                </button>

                            </div>


                            <div class="small text-muted mt-2">

                                JPG, PNG or WebP.
                                Maximum size 5 MB.

                            </div>

                        </div>



                        <!-- Hero image resizing (CSS dimensions, not destructive cropping) -->

                        <!-- =========================================================
     Start Public Hero Image Settings
========================================================= -->

                        <div class="ecb-image-sizing-panel" *ngIf="CourseDetails">

                            <!-- Start Image Settings Toolbar -->
                            <div class="ecb-image-tools-row">

                                <!-- Start Image Size Toolbar -->
                                <div class="ecb-image-tool-group">

                                    <label class="ecb-image-tool-label">
                                        Public Hero Image Size
                                    </label>

                                    <div class="ecb-image-sizing-mode-list" role="group"
                                        aria-label="Hero image size mode">

                                        <button type="button" *ngFor="let mode of imageSizeModes"
                                            class="ecb-image-sizing-mode-btn"
                                            [class.active]="CourseDetails.imageSizeMode === mode.value"
                                            [attr.aria-pressed]="CourseDetails.imageSizeMode === mode.value" [pTooltip]="
                        mode.value === 'HEIGHT'
                        ? 'Fixed Height: Set the image height while the width adjusts automatically to maintain its original proportions.'
                        : mode.value === 'WIDTH'
                        ? 'Fixed Width: Set the image width while the height adjusts automatically to maintain its original proportions.'
                        : 'Custom Size: Set both image width and height independently.'
                    " tooltipPosition="top" [showDelay]="250" (click)="changeImageSizeMode(mode.value)">

                                            <i class="bi" [ngClass]="mode.icon"></i>

                                            <span>{{ mode.label }}</span>

                                        </button>

                                    </div>

                                </div>
                                <!-- End Image Size Toolbar -->


                                <!-- Start Image Alignment Toolbar -->
                                <div class="ecb-image-tool-group">

                                    <label class="ecb-image-tool-label">
                                        Image Horizontal Alignment
                                    </label>

                                    <div class="ecb-image-alignment-list" role="group"
                                        aria-label="Image horizontal alignment">

                                        <button type="button" *ngFor="let alignment of imageAlignmentOptions"
                                            class="ecb-image-alignment-btn" [class.active]="
                        (CourseDetails.imageAlignment || 'CENTER')
                        === alignment.value
                    " [attr.aria-pressed]="
                        (CourseDetails.imageAlignment || 'CENTER')
                        === alignment.value
                    " [pTooltip]="
                        alignment.value === 'LEFT'
                        ? 'Left: Align the course image to the left side.'
                        : alignment.value === 'RIGHT'
                        ? 'Right: Align the course image to the right side.'
                        : 'Center: Keep the course image horizontally centered.'
                    " tooltipPosition="top" [showDelay]="250" (click)="changeImageAlignment(alignment.value)">

                                            <i class="bi" [ngClass]="alignment.icon"></i>

                                            <span>{{ alignment.label }}</span>

                                        </button>

                                    </div>

                                </div>
                                <!-- End Image Alignment Toolbar -->

                            </div>
                            <!-- End Image Settings Toolbar -->


                            <!-- Start Image Size Controls -->
                            <div class="ecb-image-size-controls">

                                <!-- Legacy Message -->
                                <div class="small text-muted mb-2" *ngIf="!CourseDetails.imageSizeMode">

                                    This course currently uses the original full-cover image style.
                                    Choose one of the three sizing modes to customize it.

                                </div>


                                <!-- Reset Image Size -->
                                <button type="button" class="ecb-image-sizing-reset-btn"
                                    *ngIf="CourseDetails.imageSizeMode"
                                    pTooltip="Restore the original full-cover image without applying custom image dimensions."
                                    tooltipPosition="top" (click)="CourseDetails.imageSizeMode = null">

                                    Reset to original full-cover style

                                </button>


                                <!-- Start Width and Height Fields -->
                                <div class="row g-2 mt-2" *ngIf="CourseDetails.imageSizeMode">

                                    <!-- Image Width -->
                                    <div class="col-sm-6" *ngIf="CourseDetails.imageSizeMode !== 'HEIGHT'">

                                        <label class="ecb-image-dimension-label" for="heroImageWidth">

                                            Width (px)

                                        </label>

                                        <input id="heroImageWidth" name="imageWidth" type="number"
                                            class="form-control form-control-sm ecb-image-dimension-input" min="40"
                                            max="1600" step="10" [(ngModel)]="CourseDetails.imageWidth"
                                            (ngModelChange)="normalizeImageDimension('width')"
                                            pTooltip="Image width in pixels. Allowed range: 40 to 1600px."
                                            tooltipPosition="top">

                                    </div>


                                    <!-- Image Height -->
                                    <div class="col-sm-6" *ngIf="CourseDetails.imageSizeMode !== 'WIDTH'">

                                        <label class="ecb-image-dimension-label" for="heroImageHeight">

                                            Height (px)

                                        </label>

                                        <input id="heroImageHeight" name="imageHeight" type="number"
                                            class="form-control form-control-sm ecb-image-dimension-input" min="40"
                                            max="1200" step="20" [(ngModel)]="CourseDetails.imageHeight"
                                            (ngModelChange)="normalizeImageDimension('height')"
                                            pTooltip="Image height in pixels. Allowed range: 40 to 1200px."
                                            tooltipPosition="top">

                                    </div>

                                </div>
                                <!-- End Width and Height Fields -->

                            </div>
                            <!-- End Image Size Controls -->


                            <!-- =====================================================
         Start Hero Image Preview
    ====================================================== -->


                            <!-- =========================================================
     Start Public Hero Preview
========================================================= -->

                            <div class="ecb-image-preview-section">

                                <!-- Preview Header -->
                                <div class="ecb-image-sizing-preview-header">

                                    <span class="ecb-image-preview-title">
                                        Public Course Hero Preview
                                    </span>

                                    <span class="ecb-image-preview-help"
                                        pTooltip="This preview shows how the course header will appear on the public website."
                                        tooltipPosition="top">

                                        <i class="bi bi-info-circle me-1"></i>
                                        Live Preview

                                    </span>

                                </div>


                                <!-- Start Full Hero Preview Card -->
                                <div class="ecb-image-preview-card">

                                    <!-- Start Left Content -->
                                    <div class="ecb-image-preview-content">

                                        <!-- Dynamic Course Code -->
                                        <div class="ecb-image-preview-course-code">

                                            {{ CourseDetails.courseCode || 'COURSE CODE' }}

                                        </div>


                                        <!-- Dynamic Course Title -->
                                        <h3 class="ecb-image-preview-course-title">

                                            {{ CourseDetails.courseTitle || 'Course Title' }}

                                        </h3>


                                        <!-- Static Subtitle -->
                                        <div class="ecb-image-preview-subtitle">

                                            Build the skills and confidence
                                            you need.

                                        </div>


                                        <!-- Static Button (Preview Only) -->
                                        <span class="ecb-image-preview-button">

                                            Enquire Now

                                            <i class="bi bi-arrow-right"></i>

                                        </span>

                                    </div>
                                    <!-- End Left Content -->


                                    <!-- Start Right Hero Preview -->
                                    <div #heroSizingPreview class="ecb-image-sizing-preview"
                                        aria-label="Public course hero image preview"
                                        (pointermove)="moveHeroImageResize($event)"
                                        (pointerup)="stopHeroImageResize($event)"
                                        (pointercancel)="stopHeroImageResize($event)"
                                        (lostpointercapture)="stopHeroImageResize($event)">

                                        <!-- Preview Image -->
                                        <div class="ecb-image-sizing-preview-image-box" *ngIf="imagePreviewUrl"
                                            [class.ecb-image-sizing-preview-legacy]="
            !CourseDetails.imageSizeMode
        " [attr.data-align]="
            CourseDetails.imageAlignment || 'CENTER'
        " [style.width.px]="previewImageWidth" [style.height.px]="previewImageHeight">

                                            <img [src]="imagePreviewUrl"
                                                [alt]="CourseDetails.courseTitle || 'Course image'"
                                                (load)="onHeroPreviewImageLoad($event)">

                                        </div>


                                        <!-- Resize Handle - Top Left -->
                                        <button type="button" class="ecb-image-sizing-drag-handle"
                                            *ngIf="CourseDetails.imageSizeMode && imagePreviewUrl" [class.width-only]="
            CourseDetails.imageSizeMode === 'WIDTH'
        " [class.height-only]="
            CourseDetails.imageSizeMode === 'HEIGHT'
        " pTooltip="Drag up-left to enlarge or down-right to reduce" tooltipPosition="top"
                                            aria-label="Drag to resize image"
                                            (pointerdown)="startHeroImageResize($event)">

                                            <i class="bi bi-arrows-angle-expand"></i>

                                        </button>


                                        <!-- Empty Preview -->
                                        <div class="ecb-image-sizing-preview-empty" *ngIf="!imagePreviewUrl">

                                            <i class="bi bi-image"></i>

                                            <span>No course image</span>

                                        </div>

                                    </div>
                                    <!-- End Right Hero Preview -->


                                </div>
                                <!-- End Full Hero Preview Card -->


                                <!-- Preview Footer -->
                                <div class="ecb-image-preview-footer">

                                    <i class="bi bi-info-circle me-1"></i>

                                    The preview uses your current course code, title,
                                    image dimensions and alignment.
                                    The subtitle and button are display-only.

                                </div>

                            </div>

                            <!-- =========================================================
     End Public Hero Preview
========================================================= -->

                            <!-- End Hero Image Preview -->

                        </div>

                        <!-- =========================================================
     End Public Hero Image Settings
========================================================= -->


                    </div>



                    <!-- =================================================
               Brochure
          ================================================== -->

                    <div class="col-lg-4">

                        <label class="form-label fw-semibold">
                            Course Brochure
                        </label>


                        <div class="ecb-x-admin-brochure-box">

                            <div class="ecb-x-admin-brochure-icon">

                                <i class="bi bi-file-earmark-pdf fs-4"></i>

                            </div>


                            <div class="flex-grow-1 overflow-hidden">

                                <div class="fw-semibold text-dark
                         text-truncate mb-1">

                                    {{
                                    selectedBrochureName ||
                                    (
                                    CourseDetails.brochureUrl
                                    ? 'Current course brochure'
                                    : 'No brochure uploaded'
                                    )
                                    }}

                                </div>


                                <div class="small text-muted">

                                    {{
                                    isUploadingBrochure
                                    ? 'Uploading brochure...'
                                    : 'PDF document, maximum 10 MB'
                                    }}

                                </div>


                                <a class="small fw-semibold
                         text-decoration-none
                         d-inline-flex align-items-center
                         gap-1 mt-2" *ngIf="
                    CourseDetails.brochureUrl &&
                    !isUploadingBrochure
                  " [href]="CourseDetails.brochureUrl" target="_blank" rel="noopener noreferrer">

                                    <i class="bi bi-box-arrow-up-right"></i>

                                    View Current Brochure

                                </a>
                                <br>
                                <p (click)="removeBrochure()" *ngIf="
                    CourseDetails.brochureUrl &&
                    !isUploadingBrochure
                  " [href]="CourseDetails.brochureUrl" class="small fw-semibold 
                         text-decoration-none remove-brochure
                         d-inline-flex align-items-center
                          mt-2">

                                    <i class="bi bi-trash"></i>

                                    Remove Current Brochure

                                </p>

                            </div>


                            <label class="btn btn-warning btn-sm
                       d-inline-flex align-items-center
                       gap-2 mb-0" [class.disabled]="isUploadingBrochure">

                                <div class="spinner-border spinner-border-sm" *ngIf="isUploadingBrochure">
                                </div>

                                <i class="bi bi-upload" *ngIf="!isUploadingBrochure">
                                </i>

                                Upload

                                <input type="file" hidden accept=".pdf,application/pdf" [disabled]="isUploadingBrochure"
                                    (change)="onBrochureSelected($event)">

                            </label>

                        </div>

                    </div>

                </div>

            </div>



            <!-- ===================================================
           Description
      ==================================================== -->

            <div class="ecb-x-admin-form-section">

                <div class="ecb-x-admin-section-heading">

                    <div>

                        <div class="small fw-bold text-warning
                     text-uppercase mb-1">

                            Course Content

                        </div>

                        <h3 class="fs-6 fw-bold mb-0">
                            Course Description
                        </h3>

                    </div>

                    <i class="bi bi-file-text text-muted fs-5"></i>

                </div>


                <div class="ecb-x-admin-editor-field">

                    <label class="form-label fw-semibold">
                        Short Description
                    </label>

                    <p-editor [(ngModel)]="CourseDetails.nShortDescription" name="description" [modules]="editorModules"
                        [style]="{
    height: '180px'
  }">
                    </p-editor>

                </div>


            </div>



            <!-- ===================================================
           Training Information
      ==================================================== -->
            <div class="ecb-x-admin-form-section">

                <!-- =====================================================
         Section Heading
    ====================================================== -->

                <div class="ecb-x-admin-section-heading">

                    <div>

                        <div class="small fw-bold text-warning text-uppercase mb-1">
                            Training Information
                        </div>

                        <h3 class="fs-6 fw-bold mb-0">
                            Course & Assessment Information
                        </h3>

                    </div>

                    <i class="bi bi-journal-text text-muted fs-5"></i>

                </div>


                <!-- =====================================================
         Editor Grid
    ====================================================== -->

                <div class="row g-4">


                    <!-- Course For -->

                    <div class="col-12 col-lg-6">

                        <div class="ecb-x-admin-editor-field h-100">

                            <label class="form-label fw-semibold">
                                Who is this course for?
                            </label>

                            <p-editor [(ngModel)]="CourseDetails.nCourseFor" name="nCourseFor" [modules]="editorModules"
                                [style]="{
                        height: '180px'
                    }">
                            </p-editor>

                        </div>

                    </div>


                    <!-- Covered -->

                    <div class="col-12 col-lg-6">

                        <div class="ecb-x-admin-editor-field h-100">

                            <label class="form-label fw-semibold">
                                What is covered?
                            </label>

                            <p-editor [(ngModel)]="CourseDetails.nCovered" name="nCovered" [modules]="editorModules"
                                [style]="{
                        height: '180px'
                    }">
                            </p-editor>

                        </div>

                    </div>


                    <!-- Preconditions -->

                    <div class="col-12 col-lg-6">

                        <div class="ecb-x-admin-editor-field h-100">

                            <label class="form-label fw-semibold">
                                Preconditions
                            </label>

                            <p-editor [(ngModel)]="CourseDetails.nPreconditions" [modules]="editorModules"
                                name="nPreconditions" [style]="{
                        height: '180px'
                    }">
                            </p-editor>

                        </div>

                    </div>


                    <!-- Course Duration -->

                    <div class="col-12 col-lg-6">

                        <div class="ecb-x-admin-editor-field h-100">

                            <label class="form-label fw-semibold">
                                How Long is this Course?
                            </label>

                            <p-editor [(ngModel)]="CourseDetails.nHowLongCourse" [modules]="editorModules"
                                name="nHowLongCourse" [style]="{
                        height: '180px'
                    }">
                            </p-editor>

                        </div>

                    </div>


                    <!-- Knowledge Assessment -->

                    <div class="col-12 col-lg-6">

                        <div class="ecb-x-admin-editor-field h-100">

                            <label class="form-label fw-semibold">
                                Knowledge Assessment
                            </label>

                            <p-editor [(ngModel)]="CourseDetails.nKnowledgeAssessment" [modules]="editorModules"
                                name="nKnowledgeAssessment" [style]="{
                        height: '180px'
                    }">
                            </p-editor>

                        </div>

                    </div>


                    <!-- Skills Assessment -->

                    <div class="col-12 col-lg-6">

                        <div class="ecb-x-admin-editor-field h-100">

                            <label class="form-label fw-semibold">
                                Skills Assessment
                            </label>

                            <p-editor [(ngModel)]="CourseDetails.nSkillsAssessment" [modules]="editorModules"
                                name="nSkillsAssessment" [style]="{
                        height: '180px'
                    }">
                            </p-editor>

                        </div>

                    </div>


                    <!-- Certificate Validity -->

                    <div class="col-12 col-lg-6">

                        <div class="ecb-x-admin-editor-field h-100">

                            <label class="form-label fw-semibold">
                                Certificate Validity
                            </label>

                            <p-editor [(ngModel)]="CourseDetails.nCertificateValid" [modules]="editorModules"
                                name="nCertificateValid" [style]="{
                        height: '180px'
                    }">
                            </p-editor>

                        </div>

                    </div>

                </div>

            </div>

            <!-- ===================================================
                 Read-only VETtrak synced structure
            ==================================================== -->
            <div class="ecb-x-admin-form-section ecb-vettrak-readonly-section" *ngIf="!isCreateMode">

                <div class="ecb-x-admin-section-heading">
                    <div>
                        <div class="small fw-bold text-warning text-uppercase mb-1">VETtrak Data</div>
                        <h3 class="fs-6 fw-bold mb-0">Units, Classes & Occurrences</h3>
                        <p class="small text-muted mb-0 mt-1">
                            Synced training structure is read only in this screen and can only be refreshed by VETtrak
                            sync.
                        </p>
                    </div>
                    <i class="bi bi-lock-fill text-muted fs-5"></i>
                </div>

                <details class="ecb-readonly-group" open>
                    <summary>
                        <span><i class="bi bi-calendar-event"></i> Occurrences</span>
                        <span class="ecb-readonly-count">{{ CourseDetails.occurances?.length || 0 }}</span>
                    </summary>

                    <div class="ecb-readonly-empty" *ngIf="!CourseDetails.occurances?.length">
                        No VETtrak occurrences are stored for this course.
                    </div>

                    <div class="table-responsive" *ngIf="CourseDetails.occurances?.length">
                        <table class="table table-sm ecb-readonly-table mb-0">
                            <thead>
                                <tr>
                                    <th>Occurrence</th>
                                    <th>Start</th>
                                    <th>End</th>
                                    <th>Location</th>
                                    <th>Capacity</th>
                                    <th>Seats</th>
                                    <!-- <th>Job No.</th> -->
                                    <th>Last Synced</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let occurrence of CourseDetails.occurances">
                                    <td>{{ occurrence.vettrackOccuranceId || occurrence.id || '-' }}</td>
                                    <td>{{ occurrence.startDate | date:'dd/MM/yyyy h:mm a' }}</td>
                                    <td>{{ occurrence.endDate | date:'dd/MM/yyyy h:mm a' }}</td>
                                    <td>{{ occurrence.locationName || occurrence.location || '-' }}</td>
                                    <td>{{ occurrence.capacity ?? '-' }}</td>
                                    <td>{{ occurrence.availableSeats ?? occurrence.vacancies ?? '-' }}</td>
                                    <!-- <td>{{ occurrence.vettrackJobNumber || '-' }}</td> -->
                                    <td>{{ occurrence.lastSyncedDate ? (occurrence.lastSyncedDate | date:'dd/MM/yyyy
                                        h:mm a') : '-' }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </details>

                <details class="ecb-readonly-group">
                    <summary>
                        <span><i class="bi bi-journal-check"></i> Units</span>
                        <span class="ecb-readonly-count">{{ CourseDetails.units?.length || 0 }}</span>
                    </summary>

                    <div class="ecb-readonly-empty" *ngIf="!CourseDetails.units?.length">
                        No VETtrak units are stored for this course.
                    </div>

                    <div class="table-responsive" *ngIf="CourseDetails.units?.length">
                        <table class="table table-sm ecb-readonly-table mb-0">
                            <thead>
                                <tr>
                                    <th>Code</th>
                                    <th>National Code</th>
                                    <th>Unit</th>
                                    <th>Type</th>
                                    <th>Occurrence ID</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let unit of CourseDetails.units">
                                    <td>{{ unit.code || '-' }}</td>
                                    <td>{{ unit.nationalCode || '-' }}</td>
                                    <td>{{ unit.name || '-' }}</td>
                                    <td>{{ unit.type || '-' }}</td>
                                    <td>{{ unit.fkCourseOccuranceId || '-' }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </details>

                <details class="ecb-readonly-group">
                    <summary>
                        <span><i class="bi bi-people"></i> Classes</span>
                        <span class="ecb-readonly-count">{{ CourseDetails.classes?.length || 0 }}</span>
                    </summary>

                    <div class="ecb-readonly-empty" *ngIf="!CourseDetails.classes?.length">
                        No VETtrak classes are stored for this course.
                    </div>

                    <div class="table-responsive" *ngIf="CourseDetails.classes?.length">
                        <table class="table table-sm ecb-readonly-table mb-0">
                            <thead>
                                <tr>
                                    <th>Class</th>
                                    <th>Start</th>
                                    <th>End</th>
                                    <th>Location</th>
                                    <th>Room</th>
                                    <th>Trainer</th>
                                    <th>Occurrence ID</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let classItem of CourseDetails.classes">
                                    <td>{{ classItem.name || '-' }}</td>
                                    <td>{{ classItem.startDate ? (classItem.startDate | date:'dd/MM/yyyy h:mm a') : '-'
                                        }}</td>
                                    <td>{{ classItem.endDate ? (classItem.endDate | date:'dd/MM/yyyy h:mm a') : '-' }}
                                    </td>
                                    <td>{{ classItem.location || '-' }}</td>
                                    <td>{{ classItem.room || '-' }}</td>
                                    <td>{{ classItem.primaryStaff || '-' }}</td>
                                    <td>{{ classItem.fkCourseOccuranceId || '-' }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </details>
            </div>
        </div>



        <!-- =====================================================
         Modal Footer
    ====================================================== -->

        <div class="ecb-x-admin-modal-footer" *ngIf="       !isDetailsLoading &&  CourseDetails  ">

            <button type="button" class="btn btn-outline-secondary
               d-inline-flex align-items-center gap-2" [disabled]="
          isSaving ||
          isUploadingImage ||
          isUploadingBrochure
        " (click)="closeCourseModal()">

                <i class="bi bi-x-circle"></i>

                Cancel

            </button>


            <button type="button" class="btn btn-primary
               d-inline-flex align-items-center gap-2" [disabled]="
          isSaving ||
          isUploadingImage ||
          isUploadingBrochure
        " (click)="updateCourseDetails()">

                <div class="spinner-border spinner-border-sm" *ngIf="isSaving">
                </div>

                <i class="bi bi-check2-circle" *ngIf="!isSaving">
                </i>

                {{
                isSaving
                ? 'Saving...'
                : (isCreateMode ? 'Create Course' : 'Save Changes')
                }}

            </button>

        </div>

    </div>

</div>

<!-- =========================================================
     End Edit Course Modal
========================================================= -->




<!-- Course Download Dialog -->
<p-dialog header="Download Courses" [(visible)]="showDownloadDialog" [modal]="true" [draggable]="false"
    [resizable]="false" [style]="{ width: '440px', maxWidth: '95vw' }" styleClass="ecb-course-download-dialog">

    <div class="ecb-download-content">

        <!-- Course Type -->
        <div class="ecb-download-section">

            <label class="ecb-download-label">
                Select Course Type
            </label>

            <div class="ecb-download-radio-group">

                <div class="ecb-download-option">
                    <p-radioButton name="downloadCourseType" value="ALL" [(ngModel)]="downloadCourseType"
                        inputId="downloadAll">
                    </p-radioButton>

                    <label for="downloadAll">
                        All Courses
                    </label>
                </div>

                <div class="ecb-download-option">
                    <p-radioButton name="downloadCourseType" value="SHORT" [(ngModel)]="downloadCourseType"
                        inputId="downloadShort">
                    </p-radioButton>

                    <label for="downloadShort">
                        Short Courses
                    </label>
                </div>

                <div class="ecb-download-option">
                    <p-radioButton name="downloadCourseType" value="LONG" [(ngModel)]="downloadCourseType"
                        inputId="downloadLong">
                    </p-radioButton>

                    <label for="downloadLong">
                        Long Courses
                    </label>
                </div>

            </div>

        </div>

        <!-- Description Options -->
        <div class="ecb-download-section">

            <label class="ecb-download-label">
                Include Descriptions
            </label>

            <div class="ecb-download-checkbox-group">

                <div class="ecb-download-option">
                    <p-checkbox [(ngModel)]="downloadShortDescription" [binary]="true" inputId="downloadShortDesc">
                    </p-checkbox>

                    <label for="downloadShortDesc">
                        Short Description
                    </label>
                </div>

                <div class="ecb-download-option">
                    <p-checkbox [(ngModel)]="downloadDescription" [binary]="true" inputId="downloadFullDesc">
                    </p-checkbox>

                    <label for="downloadFullDesc">
                        Full Description
                    </label>
                </div>

            </div>

        </div>

    </div>

    <!-- Footer -->
    <ng-template pTemplate="footer">

        <button type="button" class="ecb-download-cancel-btn" [disabled]="isDownloading"
            (click)="showDownloadDialog = false">
            Cancel
        </button>

        <button type="button" class="ecb-x-admin-download-button" [disabled]="isDownloading"
            (click)="downloadCourseExcel()">

            <i class="bi" [ngClass]="isDownloading
                    ? 'bi-arrow-repeat'
                    : 'bi-file-earmark-excel'">
            </i>

            {{ isDownloading ? 'Preparing...' : 'Download Excel' }}

        </button>

    </ng-template>

</p-dialog>